module.exports = __webpack_public_path__ + "img/p8.6656284a.png";